interface SupportModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export default function SupportModal({ isOpen, onClose }: SupportModalProps) {
    if (!isOpen) return null;

    const handleBackgroundClick = () => {
        onClose();
    };

    const stopPropagation = (e: React.MouseEvent) => {
        e.stopPropagation();
    };

    return (
        <div
            onClick={handleBackgroundClick}
            className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center"
        >
            <div
                onClick={stopPropagation}
                className="bg-white rounded-2xl shadow-lg max-w-sm w-full relative"
            >
                {/* Header com botão de fechar */}
                <div className="flex justify-end p-2">
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-800 text-3xl leading-none"
                        aria-label="Fechar"
                    >
                        ×
                    </button>
                </div>

                {/* Conteúdo do modal */}
                <div className="p-6 text-center">
                    <img
                        src="/qrcode-doacao.png"
                        alt="QR Code para doação"
                        className="mx-auto mb-4 w-48 h-48 object-contain"
                    />

                    <p className="text-gray-700 text-sm">
                        Curtiu a ferramenta? Me apoie com qualquer quantia, isso é de grande ajuda ❤️
                    </p>
                </div>
            </div>
        </div>
    );
}
